import { render } from "./OfficeTable.vue?vue&type=template&id=e084b0f4"
import script from "./OfficeTable.vue?vue&type=script&lang=js"
export * from "./OfficeTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__